import React from 'react';
import FooterLogo from '../assets/logo.png'; // Replace with your logo

const linkSections = [
  {
    heading: 'Company',
    links: [
      { name: 'Home', href: '/' },
      { name: 'About Us', href: '/about&portfolio' },
      { name: 'Careers', href: '/careers' },
      { name: 'Contact', href: '/contact' },
    ],
  },
  // {
  //   heading: 'Resources',
  //   links: [
  //     { name: 'Blog', href: '/blog' },
  //     { name: 'Help Center', href: '/help' },
  //     { name: 'Privacy Policy', href: '/privacy' },
  //     { name: 'Terms of Service', href: '/terms' },
  //   ],
  // },
];

const Footer = () => {
  return (
    <footer className="bg-jbsGray mx-auto text-white px-6 md:px-12 lg:px-20 py-10 pt-40 relative z-0">
      <div className="flex flex-col max-w-7xl mx-auto md:flex-row justify-between gap-10">
        {/* Left: Logo + Text */}
        <div className="flex items-start gap-4 max-w-sm">
          <img src={FooterLogo} alt="Logo" className="w-16 h-16 object-contain" />
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-3 text-white font-black">
  JBS Capacitors
</h1>

        </div>

        {/* Right: Mapped Link Sections */}
        <div className="flex flex-col sm:flex-row gap-10">
          {linkSections.map((section, index) => (
            <div key={index}>
              <h3 className="text-white font-semibold text-lg mb-3">{section.heading}</h3>
              <ul className="space-y-2 text-gray-400 text-md font-extralight">
                {section.links.map((link, i) => (
                  <li key={i}>
                    <a href={link.href} className="hover:text-white transition">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center mt-10 text-gray-500 text-xs">
        © {new Date().getFullYear()} JBS APPLIED A.I & ROBOTICS RESEARCH LTD. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
